const CHECKIN_STATUSES = {
  PROVIDE_DETAILS: "provide_details",
  PROVIDE_APAXI: "provide_apaxi",
  WAITING_F0R_APAXI: "waiting_for_apaxi",
  WAITING_FOR_DETAILS: "waiting_for_details",
  WAITING_FOR_CHECKIN: "waiting_for_checkin",
  PROCESSING: "processing",
  DONE: "done",
  MISSED: "missed",
  FAILED: "failed",
  RESTRICTED: "restricted",
  UNAVAILABLE: "unavailable",
  AIRPORT_CHECK_IN_WITH_BOARDING_DOCUMENT: "airport_check_in_with_boarding_document",
  SOME_CHECKINS_PROCESSING_SOME_MISSED: "some_checkins_processing_some_missed",
  SOME_CHECKINS_DONE_SOME_MISSED: "some_checkins_done_some_missed",
  SOME_CHECKINS_MISSED_SOME_FAILED: "some_checkins_missed_some_failed",
  SOME_CHECKINS_DONE_SOME_PROCESSING: "some_checkins_done_some_processing",
  SOME_CHECKINS_DONE_SOME_FAILED: "some_checkins_done_some_failed",
  SOME_CHECKINS_DONE_SOME_WAITING_FOR_DETAILS: "some_checkins_done_some_waiting_for_details",
  OTHER: "other",
  GROUND_DONE: "ground_done",
  GROUND_PROCESSING: "ground_processing",
  GROUND_UNAVAILABLE: "ground_unavailable",
} as const

export default CHECKIN_STATUSES
